import React from "react"
import { CalendarSettingsViewModel } from "../../calendar-settings/api/calendar-settings"
import { createHolidayChecker, createWeekendChecker } from "../../calendar-settings/utils/date"

type CanEditDate = (date: Date | string) => boolean

export const useCanEditDateByCalendarSettingsId = (
  calendarSettingsById: Record<string, CalendarSettingsViewModel>
): Record<string, CanEditDate> => {
  return React.useMemo(() => {
    const canEditDateById: Record<string, CanEditDate> = {}
    const settingIds = Object.keys(calendarSettingsById)

    settingIds.forEach((id) => {
      const calendarSetting = calendarSettingsById[id]
      const isHoliday = createHolidayChecker(calendarSetting)
      const isWeekend = createWeekendChecker(calendarSetting)

      canEditDateById[id] = (date: Date | string) => {
        return !isHoliday(date) && !isWeekend(date)
      }
    })

    return canEditDateById
  }, [calendarSettingsById])
}
